import React from "react";
import PropTypes from "prop-types";
import { Grid, Container } from "@mui/material";
import Markdown from "markdown-to-jsx";
import "@fortawesome/fontawesome-free/css/all.css";
import Link from "@openstack_dev/gatsby-theme-marketing-oif-core/src/components/Link";
import styles from "./index.module.scss";

function Template({ data }) {
  const { image, text } = data;

  return (
    <Container maxWidth="lg" className={styles.osfSectionWrapper}>
      <Grid container className={styles.osfContainer}>
        <Grid item sm={12} md={8}>
          <Link to={image.link}>
            <img src={image.src.publicURL} alt={image.alt} />
          </Link>

          <p className={styles.text}>
            <Markdown>{text}</Markdown>
          </p>
        </Grid>
      </Grid>
    </Container>
  );
}

Template.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.shape({
      src: PropTypes.shape({
        publicURL: PropTypes.string,
      }),
      alt: PropTypes.string,
      link: PropTypes.string,
    }),
    text: PropTypes.string,
  }).isRequired,
};

export default Template;
